import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { JobScheduleComponent } from './job-schedule.component';

@NgModule({
    declarations: [
        JobScheduleComponent
    ],
    imports: [
        CommonModule,
        NgbModule
    ],
    exports: [
        JobScheduleComponent
    ]
})

export class JobScheduleModule { }
